import * as React from 'react'

import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import Icon from '../Icon/Icon'

import Loader from '../../../assets/img/loader.gif'

import media from '../../../services/generateMediaQueries'
import downloadAppLink from '../../../services/redirection/downloadAppLink'

import AppStore from '../../../assets/img/app-download/app-store.png'
import PlayStore from '../../../assets/img/app-download/play-store.png'

import RightSideBarHeader from '../../../assets/img/right-sidebar-header.svg'
import MoreHeaderParticles from '../../../assets/img/more-header-particles.svg'
import { APP_NAME } from '../../../static/constants'

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 4.5rem;
  right: ${props => (props.loggedin ? '8.9rem' : '5.9rem')};
  border: none;
  background: var(--color-bg-light);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  width: 100%;
  max-width: 375px;
  opacity: 0;
  display: flex;
  flex-direction: column;
  transition: all var(--animation-duration) var(--animation-easing);
  border-radius: 6px;
  max-height: calc(100vh - 4.5rem);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const LoadingContainer = styled.div`
  min-height: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
`

const LoadingIcon = styled.img.attrs({ src: Loader })`
  height: 5rem;
  width: 5rem;
`

const Content = styled.div`
  height: 100%;
  padding: 0 !important;
  background: #ffffff;
`

const Title = styled.h1`
  font-size: 1.375rem;
  line-height: 1.625rem;
  letter-spacing: var(--letter-spacing-wider);
  color: var(--color-primary);
  font-weight: var(--font-weight-boldest);
  text-align: center;
  margin: 0 auto;
  max-width: 265px;
`

const Description = styled.p`
  font-size: 0.9375rem;
  line-height: 1.25rem;
  margin-top: 1.25rem;
  margin-bottom: 2.6875rem;
  text-align: center;
`

const StoreBubbles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Store = styled.img`
  cursor: pointer;
  height: 39px;

  &:first-child {
    margin-right: 1.1875rem;
  }
`

const MainContent = styled.div`
  padding: 20px 50px;

  ${media.lessThan('medium')`
    padding: 32px;
  `}
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: var(--color-fg);
  border: 0;
  background-color: transparent;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const BannerDiv = styled.div`
content: ' ';
    display: block;
    height: 197px;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, right top;
    background-repeat: no-repeat;
    background-size: 100%, auto;

`

const overlay = {
  zIndex: 10090,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

class DownloadAppModal extends React.Component {
  state = {
    // TODO: define initial state
  }

  modalClose = () => {
    const { onClose } = this.props

    if (onClose) {
      onClose(false)
    }
  }

  openTab = link => {
    window.open(link)
  }

  render() {
    const {
      handleClose,
      show,
      loading,
      onClose,
      children,
      CloseButton,
      zIndex,
      shouldCloseOnOverlayClick = true,
      title,
      description,
      modalState,
      accessToken,
      ...restProps
    } = this.props
    // TODO: define template

    return (
      <StyledReactModal
        isOpen={modalState}
        style={{
          overlay: {
            ...overlay,
            ...(zIndex ? { zIndex } : {}),
          },
          content,
        }}
        onRequestClose={this.modalClose}
        closeTimeoutMS={150}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        bodyOpenClassName="sticky-modal-open"
        htmlOpenClassName="sticky-modal-open"
        loggedin={accessToken}
        {...restProps}
      >
        <DefaultCloseButton onClick={this.modalClose}>
          <Icon name="x" />
        </DefaultCloseButton>
        {loading ? (
          <LoadingContainer>
            <LoadingIcon />
          </LoadingContainer>
        ) : (
          <Content>
            <BannerDiv />
            <MainContent>
              <Title>
                Enjoy a world of benefits
                <br /> with the app.
              </Title>

              <Description>
                Explore other perks exclusive for
                <br /> {APP_NAME} members.
              </Description>

              <StoreBubbles>
                <Store src={AppStore} onClick={downloadAppLink('iOS')} alt="" />
                <Store
                  src={PlayStore}
                  onClick={downloadAppLink('Android')}
                  alt=""
                />
              </StoreBubbles>
            </MainContent>
          </Content>
        )}
      </StyledReactModal>
    )
  }
}

DownloadAppModal.defaultProps = {
  // TODO: specify default props
}

DownloadAppModal.propTypes = {
  // TODO: specify prop types
}

export default DownloadAppModal
